import React from "react";
import { Card, Row, Col, Table, Badge, ProgressBar } from "react-bootstrap";
import { useAnalytics } from "../hooks/useAnalytics";
import { STATS_COLORS } from "../utils/helpers";

const DocumentAnalysisPage: React.FC = () => {
  const { analyticsData, isLoading, error } = useAnalytics(0);

  const formatTime = (seconds: number) => {
    if (seconds < 1) return `${(seconds * 1000).toFixed(0)}ms`;
    return `${seconds.toFixed(2)}s`;
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!analyticsData) return <div>No data available.</div>;

  return (
    <>
      <h2 className="my-4">Document & Paragraph Analysis</h2>
      <Row>
        <Col>
          <Card>
            <Card.Header>Analysis by Document Type</Card.Header>
            <Card.Body>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>File Type</th>
                    <th>Redaction Type</th>
                    <th>Total Files</th>
                    <th>Total Redactions</th>
                    <th>Avg Confidence</th>
                    <th>Avg Processing Time</th>
                    <th>Complexity Score</th>
                  </tr>
                </thead>
                <tbody>
                  {analyticsData.document_analysis.map((doc, index) => (
                    <tr key={index}>
                      <td>
                        <Badge bg="primary">
                          {doc.file_type.toUpperCase()}
                        </Badge>
                      </td>
                      <td>{doc.redaction_type.replace("_", " ")}</td>
                      <td>{doc.total_files}</td>
                      <td>{doc.total_redactions.toLocaleString()}</td>
                      <td>
                        <ProgressBar
                          now={doc.average_confidence * 100}
                          label={`${(doc.average_confidence * 100).toFixed(
                            1
                          )}%`}
                          variant={
                            doc.average_confidence > 0.9
                              ? "success"
                              : doc.average_confidence > 0.75
                              ? "warning"
                              : "danger"
                          }
                        />
                      </td>
                      <td>{formatTime(doc.average_processing_time)}</td>
                      <td>
                        <Badge
                          bg={
                            doc.complexity_score > 10
                              ? "danger"
                              : doc.complexity_score > 5
                              ? "warning"
                              : "success"
                          }
                        >
                          {doc.complexity_score.toFixed(2)}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DocumentAnalysisPage;
